import {
  Box,
  FormControl,
  FormHelperText,
  TextField,
  Typography,
} from '@mui/material';
import {BaseSyntheticEvent} from 'react';
import {CourseEnquiryPopupType} from './types';

type NameProps = Partial<CourseEnquiryPopupType>;

const cleanName = (value: string) => {
  return value.replace(/\s+/g, ' ').trim();
};

const Name = (props: NameProps) => {
  const {formik} = props;

  if (!formik) {
    return <></>;
  }

  const error = formik.touched.name && Boolean(formik.errors.name);

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        mt: 3,
        width: '100%',
      }}
    >
      <FormControl
        id="name"
        key="name"
        error={error}
        sx={{
          display: 'block',
          width: '100%',
        }}
      >
        <Typography
          sx={{
            color: '#333',
            fontSize: 14,
            fontStyle: 'normal',
            fontWeight: 500,
            lineHeight: '18px',
          }}
        >
          Name&#42;
        </Typography>
        <Box
          display="flex"
          alignItems="center"
          sx={{
            border: '1px solid',
            borderColor:
              error ||
              (formik.touched.countryCode && Boolean(formik.errors.countryCode))
                ? 'red'
                : '#e0e0e0',
            borderRadius: 8,
            overflow: 'hidden',
            mt: 1,
            height: 40,
            paddingLeft: 1.5,
            ':hover': {
              borderColor: '#33333390',
            },
            maxWidth: 390,
          }}
        >
          <TextField
            type="text"
            name="name"
            placeholder="Enter your name"
            value={formik.values.name}
            onChange={formik.handleChange}
            onFocus={() => {
              // setMobileNumberFocused(true);
            }}
            variant="standard"
            onBlur={(e: {target: {value: any}}) => {
              const fullyTrimmedValue = cleanName(e.target.value);
              formik.setFieldValue('name', fullyTrimmedValue, false);
              formik.validateField('name');
              formik.handleBlur(e);
            }}
            InputProps={{
              disableUnderline: true,
              sx: {
                paddingLeft: 1,
                '& .MuiInputBase-input': {
                  fontSize: 14,
                  fontWeight: 500,
                  lineHeight: '16px',
                },
              },
            }}
            fullWidth
            onWheel={(e: BaseSyntheticEvent) => e.target?.blur()}
          />
        </Box>

        {error && <FormHelperText error>{formik.errors.name}</FormHelperText>}
      </FormControl>
    </Box>
  );
};

export default Name;
